var LINK_REGEXP = /([^\s"']+\.[a-zA-Z]{2,3}([^\s"']+)?)|(https?:\/\/[^\s"']+)/;
var HTTPS_REGEXP = /^(https?:\/\/)/;
var LINK_TAG_START_REGEXP = /<a/;
export var linkToAnchor = function (link) {
    var prefix = link.match(HTTPS_REGEXP) ? '' : 'https://';
    var encodedLink = link.replace(/["\\]/g, encodeURIComponent);
    return "<a href=\"".concat(prefix).concat(encodedLink, "\" target=\"_blank\">").concat(link, "</a>");
};
export var makeLinksClickable = function (text) {
    if (text.match(LINK_TAG_START_REGEXP)) {
        return text;
    }
    return text.replace(LINK_REGEXP, linkToAnchor);
};
//# sourceMappingURL=utils.js.map